(function () {
  var YAZMA_GECIKMESI = 400;

  function metin(el) {
    return el ? String(el.value || '').trim() : '';
  }

  /**
   * Turkce serbest adres metnini parcalara ayirir.
   * "Ataturk Mah. Gul Sok. No:12 D:3" -> {mahalle, sokak, bina, daire}
   * Hicbir kalip tutmazsa metnin tamami sokak alanina dusurulur.
   */
  // "Bulvar" + "i" diye bolerdi. Sinir bunun yerine Unicode harf/rakam
  var DAIRE = /(?:^|[\s,])(?:daire|d)\s*[:.]?\s*([0-9]+[a-zA-Z]?)(?![\p{L}\p{N}])/iu;
  var KAT = /(?:^|[\s,])kat\s*[:.]?\s*[0-9]+(?![\p{L}\p{N}])/iu;
  var BINA = /(?:^|[\s,])(?:kapı\s*no|kapi\s*no|no|n)\s*[:.]?\s*([0-9]+[a-zA-Z]?(?:\/[a-zA-Z0-9]+)?)(?![\p{L}\p{N}])/iu;
  // Sondaki bosluk/nokta zorunlu: "Cumhuriyet" icindeki "mh" yakalanmasin diye.
  var MAHALLE = /([^,]*?\s(?:mahallesi|mahalle|mah|mh)\.?)(?![\p{L}\p{N}])/iu;
  var SOKAK = /([^,]*?\s(?:caddesi|cadde|cad|sokağı|sokagi|sokak|sok|sk|bulvarı|bulvari|bulvar|blv)\.?)(?![\p{L}\p{N}])/iu;
  var CIPLAK_NO = /(?:^|[\s,])([0-9]+(?:\/[a-zA-Z0-9]+)?)(?![\p{L}\p{N}])/iu;
  var KIRP = /^[\s,]+|[.,\s]+$/g;

  function adresiParcala(ham) {
    var sonuc = { mahalle: '', sokak: '', bina: '', daire: '' };
    var kalan = String(ham || '').trim();
    if (!kalan) return sonuc;

    // Daire: "D:3", "D. 3", "Daire 5"
    kalan = kalan.replace(DAIRE, function (_, no) {
      sonuc.daire = no;
      return ' ';
    });

    kalan = kalan.replace(KAT, ' ');

    // Bina: "No:54", "No 54", "Kapi No: 54"
    kalan = kalan.replace(BINA, function (_, no) {
      sonuc.bina = no;
      return ' ';
    });

    // Mahalle: "... Mah.", "... Mahallesi", "... Mh."
    kalan = kalan.replace(MAHALLE, function (parca) {
      sonuc.mahalle = parca.replace(KIRP, '');
      return ' ';
    });

    // Cadde / sokak / bulvar
    kalan = kalan.replace(SOKAK, function (parca) {
      sonuc.sokak = parca.replace(KIRP, '');
      return ' ';
    });

    // Numara belirteci olmadan yazilmis bina no: "Barbaros Bulvari 145/A"
    if (!sonuc.bina) {
      kalan = kalan.replace(CIPLAK_NO, function (_, no) {
        sonuc.bina = no;
        return ' ';
      });
    }

    kalan = kalan.replace(/[,\s]+/g, ' ').trim();
    // dogru kutuya tasir. Bos birakmak, dolu bir adresi yok saymak olurdu.
    if (!sonuc.sokak && kalan) { sonuc.sokak = kalan; kalan = ''; }
    if (!sonuc.mahalle && kalan) { sonuc.mahalle = kalan; }
    return sonuc;
  }

  var TESLIMAT_MESAJ = (function () {
    var sozluk = null;
    return function (anahtar, varsayilan) {
      if (sozluk === null) {
        sozluk = {};
        try {
          var kutu = document.querySelector('[data-teslimat-mesajlar]');
          if (kutu) sozluk = JSON.parse(kutu.textContent) || {};
        } catch (e) { sozluk = {}; }
      }
      return sozluk[anahtar] || varsayilan;
    };
  })();

  class CartTeslimat extends HTMLElement {
    connectedCallback() {
      if (this.dataset.hazir === 'true') return;
      this.dataset.hazir = 'true';

      this.il = this.querySelector('[data-teslimat-il]');
      this.ilce = this.querySelector('[data-teslimat-ilce]');
      this.mahalle = this.querySelector('[data-teslimat-mahalle]');
      this.sokak = this.querySelector('[data-teslimat-sokak]');
      this.bina = this.querySelector('[data-teslimat-bina]');
      this.daire = this.querySelector('[data-teslimat-daire]');
      this.zip = this.querySelector('[data-teslimat-zip]');
      this.tel = this.querySelector('[data-teslimat-tel]');
      this.hata = this.querySelector('[data-teslimat-hata]');
      this.kaydetKutusu = this.querySelector('[data-teslimat-kaydet]');
      this.kaydetDurumKutusu = this.querySelector('[data-teslimat-kaydet-durum]');
      if (!this.il || !this.ilce) return;

      if (this.kaydetKutusu) this.kaydetKutusu.addEventListener('change', this.kaydetDegisti.bind(this));

      if (window.ADELL_TR) this.baslat();
      else window.addEventListener('load', this.baslat.bind(this), { once: true });

      this.il.addEventListener('change', this.ilDegisti.bind(this));
      this.addEventListener('change', this.degisti.bind(this));
      this.addEventListener('input', this.degisti.bind(this));
    }

    baslat() {
      if (!window.ADELL_TR) return;
      this.ilListesiniDoldur();
      this.onDoldur();
      this.eksikleriIsaretle();
    }

    ilListesiniDoldur() {
      var parcalar = ['<option value="">' + TESLIMAT_MESAJ('seciniz', 'Seçiniz') + '</option>'];
      window.ADELL_TR.ilListesi().forEach(function (ad) {
        parcalar.push('<option value="' + ad + '">' + ad + '</option>');
      });
      this.il.innerHTML = parcalar.join('');
    }

    ilceListesiniDoldur(ilAdi, secili) {
      var ilceler = window.ADELL_TR.ilceler(ilAdi);
      if (!ilceler.length) {
        this.ilce.innerHTML = '<option value="">' + TESLIMAT_MESAJ('once_il', 'Önce il seçiniz') + '</option>';
        this.ilce.disabled = true;
        return;
      }
      var parcalar = ['<option value="">Seçiniz</option>'];
      ilceler.forEach(function (ad) {
        parcalar.push('<option value="' + ad + '"' + (ad === secili ? ' selected' : '') + '>' + ad + '</option>');
      });
      this.ilce.innerHTML = parcalar.join('');
      this.ilce.disabled = false;
    }

    onDoldur() {
      var ham = this.querySelector('[data-teslimat-on-degerler]');
      var veri = {};
      try { veri = JSON.parse(ham.textContent); } catch (e) { veri = {}; }

      var T = window.ADELL_TR;
      var il = veri.il || '';
      var ilce = veri.ilce || '';

      if (!il) il = T.postaKodundanIl(veri.zip || metin(this.zip));

      if (!il && veri.sehirAlani) {
        il = T.ilEslestir(veri.sehirAlani);
        if (!il) {
          var bulunan = T.ilceyeGoreIlBul(veri.sehirAlani);
          if (bulunan) { il = bulunan.il; if (!ilce) ilce = bulunan.ilce; }
        }
      }
      if (il && !ilce && veri.sehirAlani) ilce = T.ilceEslestir(il, veri.sehirAlani);

      if (il) {
        this.il.value = il;
        this.ilceListesiniDoldur(il, ilce);
      } else {
        // Il cikarilamadiysa ilce listesi temizlenir.
        this.il.value = '';
        this.ilceListesiniDoldur('', '');
      }

      // kayitli adresin tek parca metni ayristirilir.
      var parcali = (veri.mahalle || veri.sokak || veri.bina || veri.daire)
        ? { mahalle: veri.mahalle || '', sokak: veri.sokak || '', bina: veri.bina || '', daire: veri.daire || '' }
        : adresiParcala(veri.hamAdres);
      if (this.mahalle && !metin(this.mahalle)) this.mahalle.value = parcali.mahalle;
      if (this.sokak && !metin(this.sokak)) this.sokak.value = parcali.sokak;
      if (this.bina && !metin(this.bina)) this.bina.value = parcali.bina;
      if (this.daire && !metin(this.daire)) this.daire.value = parcali.daire;
    }

    ilDegisti() {
      this.ilceListesiniDoldur(this.il.value, '');
    }

    /** Bos kalan zorunlu alanlari sari cerceveyle isaretler. */
    eksikleriIsaretle() {
      var zorunlu = [this.il, this.ilce, this.mahalle, this.sokak, this.bina, this.daire, this.zip, this.tel];
      zorunlu.forEach(function (el) {
        if (!el) return;
        var kap = el.closest('.adell-teslimat__alan');
        if (kap) kap.classList.toggle('adell-teslimat__eksik', !metin(el));
      });
      if (this.hata) this.hata.style.display = 'none';
    }

    /** Tek satirlik adres. */
    tekSatirAdres() {
      var parcalar = [metin(this.mahalle), metin(this.sokak)];
      var bina = metin(this.bina);
      var daire = metin(this.daire);
      if (bina) parcalar.push('No: ' + bina);
      if (daire && !/^(yok|-|0)$/i.test(daire)) parcalar.push('Daire: ' + daire);
      return parcalar.filter(Boolean).join(' ');
    }

    degisti() {
      this.eksikleriIsaretle();
      clearTimeout(this._zaman);
      this._zaman = setTimeout(this.yaz.bind(this), YAZMA_GECIKMESI);
    }

    yaz() {
      clearTimeout(this._zaman);
      var govde = JSON.stringify({
        attributes: {
          teslimat_il: metin(this.il),
          teslimat_ilce: metin(this.ilce),
          teslimat_mahalle: metin(this.mahalle),
          teslimat_sokak: metin(this.sokak),
          teslimat_bina_no: metin(this.bina),
          teslimat_daire_no: metin(this.daire),
          // Parcali alanlarin birlesimi.
          teslimat_adres: this.tekSatirAdres(),
          teslimat_posta_kodu: metin(this.zip).replace(/\D/g, ''),
          teslimat_telefon: metin(this.tel)
        }
      });
      var ayar = (window.FoxTheme && FoxTheme.utils && FoxTheme.utils.fetchConfig)
        ? FoxTheme.utils.fetchConfig()
        : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      var istek = fetch('/cart/update.js', Object.assign({}, ayar, { body: govde, credentials: 'same-origin' }))
        .catch(function () {});

      this.hesabaIsle();
      return istek;
    }

    odemeAdresi() {
      var tel = metin(this.tel).replace(/\D/g, '');
      if (tel.length === 10) tel = '90' + tel;
      else if (tel.length === 11 && tel.charAt(0) === '0') tel = '9' + tel;
      return {
        address1: this.tekSatirAdres(),
        city: metin(this.ilce),
        zip: metin(this.zip).replace(/\D/g, ''),
        countryCode: 'TR',
        phone: tel.length === 12 ? '+' + tel : ''
      };
    }

    kaydetDegisti() {
      this._sonKaydedilen = null;
      if (!this.kaydetKutusu.checked) this.kaydetDurum('kapali');
    }

    kaydetDurum(tip) {
      var kutu = this.kaydetDurumKutusu;
      if (!kutu) return;
      var VARSAYILAN = {
        bekliyor: 'Kayıtlı adresinize işleniyor…',
        ok: '✓ Kayıtlı adresiniz güncellendi; ödeme adımında hazır gelecek.',
        eksik: 'Eksik alanları tamamlayınca kayıtlı adresinize işlenir.',
        hata: 'Kayıtlı adres güncellenemedi; ödeme adımında adresinizi kontrol edin.',
        kapali: 'Bu adres kayıtlı adresinize işlenmeyecek; yalnızca bu sipariş için kullanılır.'
      };
      kutu.textContent = TESLIMAT_MESAJ('kaydet_' + tip, VARSAYILAN[tip] || '');
      kutu.className = 'adell-teslimat__kaydet-durum adell-teslimat__kaydet-durum--goster' +
        (tip === 'ok' ? ' adell-teslimat__kaydet-durum--ok' : '') +
        (tip === 'hata' ? ' adell-teslimat__kaydet-durum--hata' : '');
    }

    hesabaIsle() {
      if (!this.kaydetKutusu || !this.kaydetKutusu.checked) return;
      if (this.dogrula()) { this.kaydetDurum('eksik'); return; }

      var govde = {
        ilce: metin(this.ilce),
        mahalle: metin(this.mahalle),
        sokak: metin(this.sokak),
        bina: metin(this.bina),
        daire: metin(this.daire),
        postaKodu: metin(this.zip).replace(/\D/g, ''),
        telefon: metin(this.tel)
      };
      var imza = JSON.stringify(govde);
      if (imza === this._sonKaydedilen) { this.kaydetDurum('ok'); return; }

      var self = this;
      var sira = (this._kayitSirasi = (this._kayitSirasi || 0) + 1);
      this.kaydetDurum('bekliyor');

      fetch('/apps/b2b-checkout/adresimi-guncelle', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: imza
      }).then(function (cevap) {
        if (!cevap.ok) throw new Error('http ' + cevap.status);
        if (sira !== self._kayitSirasi) return;
        self._sonKaydedilen = imza;
        if (self.kaydetKutusu.checked) self.kaydetDurum('ok');
      }).catch(function (hata) {
        console.warn('[adell-teslimat] kayitli adres guncellenemedi:', hata && hata.message);
        if (sira !== self._kayitSirasi) return;
        self._sonKaydedilen = null;
        if (self.kaydetKutusu.checked) self.kaydetDurum('hata');
      });
    }

    dogrula() {
      if (!metin(this.il) || !metin(this.ilce)) return TESLIMAT_MESAJ('il_ilce', 'Teslimat için il ve ilçe seçiniz.');
      if (!metin(this.mahalle)) return TESLIMAT_MESAJ('mahalle', 'Mahalle adını yazınız.');
      if (!metin(this.sokak)) return TESLIMAT_MESAJ('sokak', 'Cadde veya sokak adını yazınız.');
      if (!metin(this.bina)) return TESLIMAT_MESAJ('bina', 'Bina numarasını yazınız.');
      if (!metin(this.daire)) return TESLIMAT_MESAJ('daire', 'Daire numarasını yazınız; müstakil ise "yok" yazabilirsiniz.');
      var pk = metin(this.zip).replace(/\D/g, '');
      if (pk.length !== 5) return TESLIMAT_MESAJ('zip', 'Posta kodu 5 haneli olmalıdır.');
      var beklenen = window.ADELL_TR && window.ADELL_TR.postaKodundanIl(pk);
      if (beklenen && beklenen !== metin(this.il)) {
        return 'Posta kodu ' + beklenen + TESLIMAT_MESAJ('zip_il', ' iline ait. Posta kodunu veya ili düzeltiniz.');
      }
      var tel = metin(this.tel).replace(/\D/g, '');
      if (tel.length < 10) return TESLIMAT_MESAJ('tel', 'Telefon numarasını eksiksiz yazınız.');
      return '';
    }

    hataGoster(mesaj) {
      if (!this.hata) return;
      this.hata.textContent = mesaj;
      this.hata.style.display = mesaj ? 'block' : 'none';
    }
  }

  if (!customElements.get('cart-teslimat')) {
    customElements.define('cart-teslimat', CartTeslimat);
  }

  // Test edilebilirlik: ayristirma mantigi disaridan cagrilabilsin.
  window.ADELL_ADRES_PARCALA = adresiParcala;
})();
